import React from 'react';

type MenuEmptyBoxProps = {
  type?: 'category' | 'menu' | 'optionGroup' | 'order';
  isVisibleTitle?: boolean;
  isVisibleSubTitle?: boolean;
};

const MenuEmptyBox = (props: MenuEmptyBoxProps) => {
  const { type = 'category', isVisibleTitle = true, isVisibleSubTitle = true } = props;

  const content = {
    title: {
      category: '등록된 메뉴가 없습니다.',
      menu: '등록된 메뉴가 없습니다.',
      optionGroup: '등록된 옵션그룹이 없습니다.',
      order: '등록된 옵션그룹이 없습니다.',
    },
    subTitle: {
      category: (
        <>
          최초 메뉴 등록은 위메프오
          <br />
          담당 매니저가 진행해드립니다.
          <br />
          최초 메뉴 등록 후 직접 관리해주세요.
        </>
      ),
      menu: (
        <>
          메뉴 추가 버튼을 클릭해
          <br />
          메뉴를 등록해 주세요.
        </>
      ),
      optionGroup: (
        <>
          옵션 그룹 추가 버튼을 클릭해
          <br />
          옵션을 등록해 주세요.
        </>
      ),
      order: <>메뉴 등록 후 이용해 주세요.</>,
    },
  };

  return (
    <div className="box-empty">
      <h4 className="screen-out">카테고리</h4>
      <img
        src="//image.thecupping.co.kr/partners/web/img-empty-data@2x.png"
        width="140"
        height="140"
        className="img-empty"
        alt=""
      />
      {isVisibleTitle && <p className="desc-empty">{content.title[type]}</p>}
      {isVisibleSubTitle && <p className="desc-empty-info">{content.subTitle[type]}</p>}
    </div>
  );
};

export default MenuEmptyBox;
